<cmps-wait-status *ngIf="state?.pending?.goals"></cmps-wait-status>
<ng-container>
    <div class="set-goals-container">
        <div
            class="recent-goals-container p-0"
            [class.collapse]="goalReviewCollapsed"
        >
            <cmps-recent-goals-commitment
                [commitmentKpis]="state?.commitmentKpis"
                [focusKpis]="state?.focusKpis"
                [goalsFromOtherCommitments]="state?.goalsFromOtherCommitments"
                [selectedGoalTrackingId]="_selected?.tracking_id"
                [isDisabled]="disabled"
                [goalThresholds]="goalThresholds"
                [approval]="approval"
                [newFocusSelectorWithYield]="newFocusSelectorWithYield"
                (sortChange)="onRecentGoalsSort($event)"
                (updateGoal)="onChangeSelectedGoal($event, true)"
                (reviewGoal)="onChangeSelectedGoal($event, false)"
                (reviewReadOnlyGoal)="
                    onChangeSelectedGoal($event, false, true, true)
                "
                (createGoal)="onNewGoalClick()"
                (manageGoal)="manageGoal.emit()"
                (isOriginalWithDraftTrackingIdMap)="
                    _isOriginalWithDraftTrackingIdMap = $event
                "
            >
            </cmps-recent-goals-commitment>
        </div>

        <div
            class="goal-creator-review-container"
            [class.expand]="goalReviewCollapsed"
        >
            <div class="expand-collapse-container">
                <button
                    class="expand-collapse-button"
                    (click)="goalReviewCollapsed = !goalReviewCollapsed"
                >
                    <cmps-icon
                        [svgIcon]="
                            goalReviewCollapsed
                                ? 'chevron-right'
                                : 'chevron-left'
                        "
                    ></cmps-icon>
                </button>
            </div>
            <cmps-goal-detail-commitment
                [storePathPrefix]="storePathPrefix"
                [goal]="_selected"
                [performerId]="performerId"
                [focus]="focus"
                [hideEditButton]="hideEditButton"
                [hideCloseDeleteButton]="hideCloseDeleteButton"
                [openGoalDetailsInEditMode]="openGoalDetailsInEditMode"
                (onSaveGoalClick)="onSaveGoalClick($event)"
                (onUpdateGoalStatusClick)="onUpdateGoalStatusClick($event)"
                (onGoalHistoryClick)="onGoalHistoryClick($event)"
                (onSelectedMetric)="_selected = $event"
                (onGoalCloseClick)="goalCloseClick($event)"
                [selectedGoalItemId]="_selected?.goalId"
                [goalsFromOtherCommitments]="state?.goalsFromOtherCommitments"
                [isSelectedGoalShared]="_selected?.shared"
                [commitmentKpis]="state?.commitmentKpis"
                [isGoalFromOtherCommitment]="isGoalFromOtherCommitment"
                [disabled]="disabled"
                [isGeneric]="isGeneric"
                [activeMetricId]="activeMetricId"
                [isOriginalWithDraftTrackingIdMap]="
                    _isOriginalWithDraftTrackingIdMap
                "
                [goalThresholds]="goalThresholds"
                [focusSelectionParams]="focusSelectionParams"
            >
            </cmps-goal-detail-commitment>
        </div>
    </div>
</ng-container>
